module.exports = __webpack_public_path__ + "img/政务4.68473ed9.png";